import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

import { AmenitiesRoomVmPipe } from '@hotels/hotel-detail/pipes/room-amenities-vm.pipe';
import { HotelAmenity } from '@hotels/hotel-detail/entities/hotel-detail.response';
import { HotelRoomAmenities } from '@hotels/hotel-results/entities/hotel-searched';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';
import {
  TypographyColor, TypographyFontFamily, TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';
import {
  ButtonLinkIconPosition, ButtonLinkType
} from '@design-system/components/molecules/button-link/entities/button-link.types';

@Component({
  selector: 'app-hotel-room-amenities',
  templateUrl: './hotel-room-amenities.component.html',
  styleUrls: ['./hotel-room-amenities.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HotelRoomAmenitiesComponent {

  public readonly AMENITIES_BASE_PATH: string = 'web/travel/amenities';

  @Input() amountVisibleAmenities: number = 7;
  @Input() isMobile: boolean = false;
  @Output() toggleAmenities: EventEmitter<void> = new EventEmitter<void>();

  private _amenities: HotelRoomAmenities[];
  public roomAmenitiesWithIcon: HotelAmenity[];
  public showAmenitiesModal: boolean;
  public showAmenitiesModalDesktop: boolean;

  public readonly chevronRight = Icon.ChevronRight;

  public readonly fontColor = TypographyColor;
  public readonly fontSize = TypographyFontSize;
  public readonly fontFamily = TypographyFontFamily;

  public readonly buttonLinkType = ButtonLinkType;
  public readonly buttonLinkIconPosition = ButtonLinkIconPosition;

  constructor(
    private amenitiesRoomVmPipe: AmenitiesRoomVmPipe
  ) {
    this.showAmenitiesModalDesktop = false;
    this.showAmenitiesModal = false;
  }

  public get showSeeMore(): boolean {
    return this.amenities?.length > this.amountVisibleAmenities || this.noHasAmenityIcons;
  }

  public get hasAmenityIcons(): boolean {
    return this.roomAmenitiesWithIcon.some(amenity => amenity.Icon);
  }

  public get noHasAmenityIcons(): boolean {
    return this.roomAmenitiesWithIcon.some(amenity => !amenity.Icon);
  }

  public get showTitle(): boolean {
    return this.isMobile ? this.isMobile : !this.hasAmenityIcons;
  }

  public toggleShowAmenitiesModal(): void {
    if (this.isMobile) {
      this.showAmenitiesModal = !this.showAmenitiesModal;
      this.toggleAmenities.emit();
    } else {
      this.showAmenitiesModalDesktop = !this.showAmenitiesModalDesktop;
    }
  }

  public get amenities(): HotelRoomAmenities[] {
    return this._amenities;
  }

  @Input()
  public set amenities(value: HotelRoomAmenities[]) {
    this._amenities = value;

    if (this._amenities) {
      this.roomAmenitiesWithIcon = this.amenitiesRoomVmPipe.transform(this._amenities, this.amountVisibleAmenities, false);
    }
  }

}
